import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { PageHero } from '../components/ui/PageHero';
import { ButtonLink } from '../components/ui/ButtonLink';
export function NotFound() {
  usePageMeta('Page Not Found | Avenqor Talent Search', 'The page you are looking for could not be found.');
  return <PageHero eyebrow="Page not found" title="This page could not be found." intro="The page may have moved, or the address may be incorrect." data-id="element-536" data-mp="1560n69vhjzue">
      <div className="flex flex-col gap-3 sm:flex-row" data-id="element-537" data-mp="1f2vo0zf8ecbu">
        <ButtonLink to="/" variant="gold" data-id="element-538" data-mp="1f1asb6h6knce">
          Return Home
        </ButtonLink>
        <ButtonLink to="/contact" variant="outlineLight" data-id="element-539" data-mp="1jv5au6l1uw9w">
          Contact Our Team
        </ButtonLink>
      </div>
    </PageHero>;
}